import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Properties from './components/Properties';
import PropertyDetails from './components/PropertyDetails';
import './style.css';

const url = window.location.href;
const newUrl = new URL(url);
const pkey = newUrl.searchParams.get("pkey");
const aid = newUrl.searchParams.get("aid");

if (pkey) localStorage.setItem("pkey", pkey);
if (aid) localStorage.setItem("aid", aid);

export default () => (
  <div>
    <Switch>
      <Route exact path="/" component={Properties} />
      <Route exact path="/property" component={Properties} />
      <Route path="/property/:id" component={PropertyDetails} />
    </Switch>
  </div>
);



// WEBPACK FOOTER //
// ./src/App.js